import { render, staticRenderFns } from "./ReceiverItemEditLicensesPage.vue?vue&type=template&id=17caebf8&"
import script from "./ReceiverItemEditLicensesPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverItemEditLicensesPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverItemEditLicensesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports